// src/bundles/htmlacademy-task.js

'use strict';

// Задать __webpack_public_path__, который укажет вебпаку откуда брать асинхронные чанки
// Можно было бы и заинлайнить сверху, т.к. в commonjs сначала выполнится все, что перед require()
// Но лучше вынести в модуль и подключить в первую очередь, т.к. в будущем могут быть добавлены ES-импорты
// А там модули импорты выполняются ДО выполнения кода модуля
// Подробнее тут https://webpack.js.org/guides/public-path/#on-the-fly
const {entryScript, assetsPath} = require('../client/set-assets-path-based-on-entry-script');
// Не удалять, не модифицировать

const {getModules} = require('../client/task-types');
const {ACE_WORKER_DIR} = require('../common/constants');
const {setLang} = require('../common/wrappers/i18n.js');
const {setRoutes} = require('../client/wrappers/routes');
const {renderTemplate} = require('../render-async');

const getRoot = () => typeof window === 'object' ? window : global;

const undoPropsAssign = [];

const preserveGlobalProperties = (propNames /* , callback*/) => {
  const root = getRoot();

  // assign props
  propNames.forEach((name) => {
    // add destroy action
    if (root.hasOwnProperty(name)) {
      const value = root[name];
      undoPropsAssign.push(() => {
        root[name] = value;
      });
    } else {
      undoPropsAssign.push(() => delete root[name]);
    }

    // assign
    root[name] = null;
  });
};

const taskStorage = {
  routes: {},
};

window.HtmlacademyTask = {
  setRoutes(routes) {
    taskStorage.routes = routes;
  },
  setup(callback) {
    taskStorage.setupCallback = callback;
  },
  setupAssets(assets) {
    taskStorage.assets = assets;
  }
};

const undefault = ({default: v}) => v;

const taskType = entryScript.dataset.taskType;
const modules = getModules(taskType);

preserveGlobalProperties(modules.componentNames);

setTimeout(async () => {
  const {routes} = taskStorage;
  let {assets} = taskStorage;
  let readonly = entryScript.dataset.readonly || false;

  const lang = entryScript.dataset.lang;
  // Задать язык для всего приложения
  setLang(lang);

  // Дата-атрибуты имеют преимущество перед легаси HtmlacademyTask.setRoutes, находящемся в след. скрипте
  const routeTask = entryScript.dataset.routeTask || routes.task;
  const routeCheck = entryScript.dataset.routeCheck || routes.check;

  // Задать маршруты для всего приложения
  setRoutes({
    task: routeTask,
    check: routeCheck
  });

  const {url, rootSelector} = entryScript.dataset;

  const isDarkTheme = typeof entryScript.dataset.isDarkTheme !== 'undefined';

  if (url && rootSelector) {
    const res = await fetch(url);
    const data = await res.json();
    const markup = await renderTemplate(taskType, {
      ...data,
      assetsPath,
      aceTheme: isDarkTheme ? 'ace/theme/ha-dark' : 'ace/theme/ha-light-default',
      isDarkTheme
    });
    if (data.assets) {
      assets = data.assets;
    }

    if (data.check && data.check.client) {
      const $script = document.createElement('script');
      $script.innerHTML = data.check.client;
      document.body.appendChild($script);
    }

    const $root = document.querySelector(rootSelector);
    $root.insertAdjacentHTML('afterbegin', markup);
    readonly = data.readonly;
  }

  const aceWorkerPath = assetsPath + ACE_WORKER_DIR;
  const results = await Promise.all(modules.create({
    assetsPath,
    aceWorkerPath
  }));

  const [
    getTask,
    getView,
    getRunner,
    getChecker,
  ] = results.slice(1).map(undefault);

  const task = getTask({assets});
  window.HtmlacademyTask = task;

  const view = getView();
  const runner = getRunner();
  const checker = getChecker();

  ['isSolved'].forEach((key) => {
    if (entryScript.dataset[key]) {
      window.document.body.dataset[key] = (
        entryScript.dataset[key]
      );
    }
  });

  task.setComponents(view, runner, checker);
  task.readonly = readonly;

  task.setup(taskStorage.setupCallback);
  undoPropsAssign.forEach((fn) => fn());
}, 0);
